import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { SessionModel } from './../../../session/entities/sessionModel';
import { IAppState } from './../../../appState/app.state';
import { Store } from '@ngrx/store';
import { environment } from './../../../../environments/environment';

import { IRegisterIkService } from './registerIk.service.Interface';
import { RegisterIkModel } from '../entities/registerIkModel';
import { IkRegistriertAction } from '../../../appState/app.actions';
import { AppState } from '../../../appState/appStateStore.module';

@Injectable()
export class RegisterIkService implements IRegisterIkService {

  constructor(private http: HttpClient, private store: Store<AppState>) {}

    register(registerIk: RegisterIkModel): Promise<boolean> {
        const url = environment.apiBaseUrl + `registration/start`;
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');
            
        const promise = new Promise<boolean>((resolve, reject) => {
            this.http.post<boolean>(url, registerIk, {headers: headers})
                .subscribe( (isRegistrated: boolean) => {
                  this.store.dispatch( new IkRegistriertAction());
                  resolve(isRegistrated);
                },
              (err) => {
                const msg = err.error;
                if (msg.Message) {
                    if (msg.Message.indexOf('Sicherheitsfrage') >= 0) {
                      reject(msg.Message);
                    }
                    if (msg.Message.indexOf('IK was not found') >= 0) {
                      reject('Geben Sie einen gültigen Benutzernamen ein.');
                    }
                    if (msg.Message.indexOf('IK is already in registration-process') >= 0) {
                      reject('Es liegt bereits eine Registrierung für diesen Benutzernamen vor.');
                    }
                    if (msg.Message.indexOf('IK is active') >= 0) {
                      reject('Der Benutzername ist bereits aktiv.');
                    }
                }
                reject('Ihre Registrierung ist fehlgeschlagen.');
              });
        });
        return promise;
    }

    checkUser(usertoCheck: RegisterIkModel): Promise<boolean> {
      const url = environment.apiBaseUrl + `registration/checkUser`;
      const headers = new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/json');

      const promise = new Promise<boolean>((resolve, reject) => {
        this.http.post<boolean>(url, usertoCheck, {headers: headers})
          .subscribe((isValid: boolean) => {
            this.store.dispatch(new IkRegistriertAction());
            resolve(isValid);
          }, (err) => {
            const msg = err.error;
            if (msg.Message) {
              if (msg.Message.indexOf('Sicherheitsfrage') >= 0) {
                reject(msg.Message);
              }
              if (msg.Message.indexOf('IK was not found') >= 0) {
                reject('Geben Sie einen gültigen Benutzernamen ein.');
              }
              if (msg.Message.indexOf('IK is already in registration-process') >= 0) {
                reject('Es liegt bereits eine Registrierung für diesen Benutzernamen vor.');
              }
              if (msg.Message.indexOf('IK is active') >= 0) {
                reject('Der Benutzername ist bereits aktiv.');
              }
            }
            reject('Der Benutzername ist ungültig. ' + msg.Message);
          });
      });

      return promise;
    }
}



// WEBPACK FOOTER //
// ./src/app/account/register/services/registerIk.service.ts